import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';

// STYLES
import { ShowMovieVotesStyled, VotesTooltipPopperComponent } from './styles';

// HELP
import ShowMovieVotesDetails from './ShowMovieVotesDetails';

function ShowMovieVotes({ data, hasTooltip }) {
  const [t] = useTranslation();

  if (!Array.isArray(data)) {
    return null;
  }

  const [likes, dislikes] = data;

  const hasLikesTooltip = hasTooltip && likes.count > 0;
  const hasDislikesTooltip = hasTooltip && dislikes.count > 0;

  const likesTooltipTitle = hasLikesTooltip ? (
    <ShowMovieVotesDetails title={t('common.liked')} peopleList={likes.voters} />
  ) : (
    ''
  );

  const dislikesTooltipTitle = hasDislikesTooltip ? (
    <ShowMovieVotesDetails title={t('common.disliked')} peopleList={dislikes.voters} />
  ) : (
    ''
  );

  const defaultTooltipProps = {
    PopperComponent: VotesTooltipPopperComponent,
    placement: 'bottom-start',
    enterTouchDelay: 100,
  };

  return (
    <ShowMovieVotesStyled className="movie-votes">
      <Tooltip {...defaultTooltipProps} title={likesTooltipTitle}>
        <div
          className={clsx('movie-votes__thumb', hasLikesTooltip && 'movie-votes__thumb--tooltip')}
        >
          <ThumbUpIcon />
          <Typography className="p2">{likes.count}</Typography>
        </div>
      </Tooltip>
      <Tooltip {...defaultTooltipProps} title={dislikesTooltipTitle}>
        <div
          className={clsx(
            'movie-votes__thumb',
            hasDislikesTooltip && 'movie-votes__thumb--tooltip',
          )}
        >
          <ThumbDownIcon />
          <Typography className="p2">{dislikes.count}</Typography>
        </div>
      </Tooltip>
    </ShowMovieVotesStyled>
  );
}

ShowMovieVotes.defaultProps = {
  hasTooltip: true,
};

ShowMovieVotes.propTypes = {
  data: PropTypes.array.isRequired,
  hasTooltip: PropTypes.bool,
};

export default React.memo(ShowMovieVotes);
